var _title, _desc, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGraphV2 = function SvgGraphV2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "72D3AF81-2CB3-48D0-93FE-BB00695FCA73@1x")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5,13 L5,18 L7,18 L7,13 L5,13 Z M4,12 L8,12 L8,19 L4,19 L4,12 Z M11,10 L11,18 L13,18 L13,10 L11,10 Z M10,9 L14,9 L14,19 L10,19 L10,9 Z M17,5 L17,18 L19,18 L19,5 L17,5 Z M16,4 L20,4 L20,19 L16,19 L16,4 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Table-Visualization-B14",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tables-Articles-Vis-B14-landing",
    transform: "translate(-1347.000000, -94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button---Filled",
    transform: "translate(1336.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Chart",
    transform: "translate(7.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGraphV2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/graph-v2.d0dfd5df.svg";
export { ForwardRef as ReactComponent };